@if (!(isLoading$ | async)) {
  <div class="events">
    <button mat-button (click)="onAddEventClick()" class="loginButton">
      <mat-icon>add_circle_outline</mat-icon>
      <span class="toolbar-button-label">登録はこちら</span>
    </button>
    <mat-icon
      class="eventHelp"
      matTooltip="上記カレンダーで期間指定された範囲の出来事を表示しています。（1日5件までの表示。詳細はCSVファイルをご覧ください。）"
      >help_outline</mat-icon
      >
      <app-csv-download
        [id]="csvId"
        [fileName]="csvFileName"
        [csv]="csvData$ | async"
        [loading]="csvLoading$ | async"
        [artist]="selectedArtist$ | async"
        >
      </app-csv-download>
      @if ((events$ | async)?.length == 0) {
        <div
          class="event"
          fxLayout
          fxLayoutAlign="space-between center"
          >
          出来事は登録されていません。
        </div>
      }
      @if ((events$ | async)?.length > 0) {
        @for (event of events$ | async; track event) {
          <div
            matRipple
            [class.selected]="isSelected(event, selectedEventDate$ | async)"
            (click)="selectEvent(event)"
            >
            <div class="event">
              <div class="event-header" fxLayout fxLayoutAlign="space-between center">
                <div class="date">{{ event.date }}</div>
                <div class="category category-id-{{ event.categoryId }}">
                  {{ event.categoryId | eventCategory }}
                </div>
              </div>
              <div class="event-content" fxLayout fxLayoutAlign="space-between center">
                <div class="title">{{ event.title }}</div>
                @if (event.url) {
                  <button
                    mat-icon-button
                    (click)="onUrlClick($event, event.url)"
                    (mousedown)="$event.stopPropagation()"
                    >
                    <mat-icon>open_in_new</mat-icon>
                  </button>
                }
              </div>
            </div>
            <mat-divider></mat-divider>
          </div>
        }
      }
    </div>
  } @else {
    <div class="in-progress" fxLayout fxLayoutAlign="center center">
      <app-music-note></app-music-note>
    </div>
  }

